<div class="metrics-container">
  <div class="metrics-header">
    <h1>📊 Detailed Metrics Dashboard</h1>
    <p>Data from Firestore paths: /metrics/digitalcard/create, /metrics/digitalcard/update, /metrics/digitalcard/delete</p>
    <button class="refresh-btn" (click)="refreshMetrics()" [disabled]="isLoading">
      <span *ngIf="!isLoading">🔄 Refresh</span>
      <span *ngIf="isLoading">⏳ Loading...</span>
    </button>
  </div>

  <div class="loading-state" *ngIf="isLoading">
    <div class="loading-spinner"></div>
    <p>Loading metrics data...</p>
  </div>

  <div class="metrics-content" *ngIf="!isLoading">
    <!-- Time Frame Navigation -->
    <div class="timeframe-nav">
      <button 
        class="nav-btn" 
        [class.active]="selectedTimeFrame === 'overall'"
        (click)="selectedTimeFrame = 'overall'">
        Overall Metrics
      </button>
      <button 
        class="nav-btn" 
        [class.active]="selectedTimeFrame === 'monthly'"
        (click)="selectedTimeFrame = 'monthly'">
        Monthly Metrics
      </button>
      <button 
        class="nav-btn" 
        [class.active]="selectedTimeFrame === 'yearly'"
        (click)="selectedTimeFrame = 'yearly'">
        Yearly Metrics
      </button>
    </div>

    <!-- Overall Metrics Section -->
    <div class="metrics-section" *ngIf="selectedTimeFrame === 'overall'">
      <h2>📈 Overall Metrics (All Time)</h2>
      <div class="metrics-grid">
        <div class="metric-category" *ngFor="let category of displayMetrics.overall">
          <div class="category-header">
            <h3>{{ getOperationIcon(category.title.split(' ')[0].toLowerCase()) }} {{ category.title }}</h3>
            <span class="total-badge">Total: {{ category.total }}</span>
          </div>
          
          <div class="metric-entries">
            <div class="metric-entry" *ngFor="let entry of category.data">
              <div class="entry-info">
                <span class="entry-name">{{ entry.name }}</span>
                <span class="entry-type">{{ getEventTypeLabel(entry.eventType) }}</span>
                <span class="entry-category" *ngIf="entry.category">{{ entry.category }}</span>
                <span class="entry-subcategory" *ngIf="entry.subcategory">{{ entry.subcategory }}</span>
              </div>
              <div class="entry-value">{{ entry.value }}</div>
            </div>
            
            <div class="no-data" *ngIf="category.data.length === 0">
              <p>No data available</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Monthly Metrics Section -->
    <div class="metrics-section" *ngIf="selectedTimeFrame === 'monthly'">
      <h2>📅 Monthly Metrics</h2>
      
      <div class="month-selector">
        <div class="month-tabs">
          <button 
            class="month-tab" 
            *ngFor="let monthKey of getMonthlyKeys().slice(0, 6)"
            [class.active]="selectedTimeFrame === 'monthly-' + monthKey"
            (click)="selectedTimeFrame = 'monthly-' + monthKey">
            {{ formatMonthKey(monthKey) }}
          </button>
        </div>
      </div>

      <div class="monthly-metrics">
        <div class="month-section" *ngFor="let monthKey of getMonthlyKeys().slice(0, 3)">
          <h3>{{ formatMonthKey(monthKey) }}</h3>
          
          <div class="metrics-grid">
            <div class="metric-category" *ngFor="let category of displayMetrics.monthly[monthKey]">
              <div class="category-header">
                <h4>{{ getOperationIcon(category.title.split(' ')[0].toLowerCase()) }} {{ category.title }}</h4>
                <span class="total-badge">{{ category.total }}</span>
              </div>
              
              <div class="metric-entries">
                <div class="metric-entry" *ngFor="let entry of category.data">
                  <div class="entry-info">
                    <span class="entry-name">{{ entry.name }}</span>
                    <span class="entry-type">{{ getEventTypeLabel(entry.eventType) }}</span>
                    <span class="entry-category" *ngIf="entry.category">{{ entry.category }}</span>
                  </div>
                  <div class="entry-value">{{ entry.value }}</div>
                </div>
                
                <div class="no-data" *ngIf="category.data.length === 0">
                  <p>No data</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Yearly Metrics Section -->
    <div class="metrics-section" *ngIf="selectedTimeFrame === 'yearly'">
      <h2>📊 Yearly Metrics</h2>
      
      <div class="yearly-metrics">
        <div class="year-section" *ngFor="let year of getYearlyKeys()">
          <h3>{{ year }}</h3>
          
          <div class="metrics-grid">
            <div class="metric-category" *ngFor="let category of displayMetrics.yearly[year]">
              <div class="category-header">
                <h4>{{ getOperationIcon(category.title.split(' ')[0].toLowerCase()) }} {{ category.title }}</h4>
                <span class="total-badge">{{ category.total }}</span>
              </div>
              
              <div class="metric-entries">
                <div class="metric-entry" *ngFor="let entry of category.data">
                  <div class="entry-info">
                    <span class="entry-name">{{ entry.name }}</span>
                    <span class="entry-type">{{ getEventTypeLabel(entry.eventType) }}</span>
                    <span class="entry-category" *ngIf="entry.category">{{ entry.category }}</span>
                  </div>
                  <div class="entry-value">{{ entry.value }}</div>
                </div>
                
                <div class="no-data" *ngIf="category.data.length === 0">
                  <p>No data</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Path Information -->
    <div class="path-info">
      <h3>📂 Firestore Paths</h3>
      <div class="path-list">
        <div class="path-item">
          <span class="path-label">Create:</span>
          <code>/metrics/digitalcard/create</code>
        </div>
        <div class="path-item">
          <span class="path-label">Update:</span>
          <code>/metrics/digitalcard/update</code>
        </div>
        <div class="path-item">
          <span class="path-label">Delete:</span>
          <code>/metrics/digitalcard/delete</code>
        </div>
      </div>
    </div>
  </div>
</div>
